import React, { useState } from 'react';
import './courseCertificate.css'

function C2wCourseCertificate({type}) {

    return (
        <div className='C2wCourseCertificate_ctn'>
            <div className='C2wCourseCertificate_card'>
                <div className='C2wCourseCertificate_card_certificateHolder'>
                    <img src='/assets/images/courseDetails/Certifiacte.png' alt='/'/>
          
                </div>

                <div className='C2wCourseCertificate_card_text'>
                    <div className='C2wCoureseDetailComponentHeading_ctn'>
                        <div className='heading'>
                            <span className='headingSpan'>{ type === 'Online' ? 'Get a certificate ' : 'Get a separate certificate '}</span>
                            { type === 'Online' ? 'after completing the course' : 'after completing each module in the course'}
                        </div>
                    </div>
                    <p>{'Showcase your skills – get a certificate upon completion.'}</p>
                </div>
            </div>
        </div>
    )
}

export default C2wCourseCertificate
